<template>
  <div
    class="item mb-0 shadow-sm pl-1 pr-1 justify-content-center"
    :class="{
      'bg-dark text-white': item.id === value
    }"
    :title="name"
    @click="updateActive(item.id)"
    v-if="name !== 'warehouse'"
    style="display: flex;"
  >
    <div
      style="
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        direction: rtl;
      "
    >
      {{ name }}
    </div>
    <div class="pl-3">
      <b-button
        class="mx-3 my-0 p-0"
        :class="{
          'text-dark': item.id != value,
          'text-white': item.id === value,
          'text-danger': removeConfirm === 1
        }"
        @click="removeContainer(item)"
        @blur="resetRemoveConfirmation()"
        style="outline: none; background: transparent; border: none; box-shadow: none;"
      >
        <b-icon-trash-fill></b-icon-trash-fill>
      </b-button>
      <b-button
        class="mx-3 my-0 p-0"
        :class="{
          'text-dark': item.id != value,
          'text-white': item.id === value,
          'text-danger': editConfirm === 1
        }"
        @click="editContainer(item)"
        @blur="resetEditConfirmation()"
        style="outline: none; background: transparent; border: none; box-shadow: none;"
      >
        <b-icon-gear-fill></b-icon-gear-fill>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContainerWidgetSummary',
  props: ['item', 'name', 'value'],
  data() {
    return {
      removeConfirm: 0,
      editConfirm: 0,
    };
  },
  methods: {
    updateActive(value) {
      this.$emit('input', value);
    },
    resetRemoveConfirmation() {
      this.removeConfirm = 0;
    },
    resetEditConfirmation() {
      this.editConfirm = 0;
    },
    removeContainer(value) {
      this.removeConfirm += 1;
      if (this.removeConfirm === 2) {
        this.$emit('remove_container', value);
      }
    },
    editContainer(value) {
      this.editConfirm += 1;
      if (this.editConfirm === 2) {
        this.$emit('edit_container', value);
      }
    },
  },
};
</script>

<style scoped>

</style>
